import { render, staticRenderFns } from "./demandDetails.vue?vue&type=template&id=4379bfda&scoped=true&"
import script from "./demandDetails.vue?vue&type=script&lang=js&"
export * from "./demandDetails.vue?vue&type=script&lang=js&"
import style0 from "./demandDetails.vue?vue&type=style&index=0&id=4379bfda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379bfda",
  null
  
)

export default component.exports